import { useMutation } from '@tanstack/vue-query'
import { userSwitchLeaveRepository, userSwitchRepository } from '~/repository/user-switch/user-switch.repository'

export const userSwitch = () => {
  return useMutation({
    mutationFn: async (data: { identify: string }) => await userSwitchRepository(data),
    onSuccess: (_data, variables) => {
      const config = useRuntimeConfig().public
      navigateTo(`${config.my_rdp_url}`, {
        external: true
      })
      useAuth().updateSession()
      queryClient().invalidateQueries()
      toastSuccess({ title: `Vous êtes connecté en tant que ${variables.identify}` })
    }
  })
}

export const useSwitchLeave = () => {
  return useMutation({
    mutationFn: async () => await userSwitchLeaveRepository(),
    onSuccess: () => {
      useAuth().updateSession()
      queryClient().invalidateQueries()
      toastSuccess({ title: "Retour à votre compte d'origine avec succès " })
    }
  })
}